export default {
  micrositeInfo: {},
  micrositeMembers: [],
  micrositeEvents: [],
}
